export default function sortWorkshopsByOrder(workshops, orderBy) {
    if (!workshops) return workshops;

    const sorted = [...workshops];

    if (orderBy === "distance") {
        sorted.sort((a, b) => a.distance - b.distance);
    } else if (orderBy === "rating") {
        sorted.sort((a, b) => (b.ratings?.rating ?? 0) - (a.ratings?.rating ?? 0));
    }

    return sorted.map((workshop, index) => ({
        ...workshop,
        orderNr: index + 1,
    }));
}